import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import addFileIcon from '../../../../_metronic/assets/images/svg/data-room/add-file-icon.svg'
import folderIcon from '../../../../_metronic/assets/images/svg/data-room/blue-folder-icon.svg'
import moreOption from '../../../../_metronic/assets/images/svg/data-room/more-options-small-icon.svg'
import DataRoomFilesTableRow from '../components/DataRoomFilesTableRow'
import { useIntl } from 'react-intl'
import { UploadDrawer } from '../components/data-room-drawer/UploadDrawer'
import DeleteFileModal from '../components/data-room-drawer/DeleteFileModal'
import { UploadOptionsDrawer } from '../components/data-room-drawer/UploadOptionsDrawer'
import { toast } from 'react-toastify'
import {
  getAllContent,
  addContent,
  getAllFoldersList,
  getBreadcrumbList,
  getCompanyChildrenList,
} from '../core/_requests'
import { useAuth } from '../../auth'
import { AddFolderModal } from './AddFolderModal'
import { useMoveToFolderData } from '../core/FileToFolderAuth'
import { ShareDrawer } from '../components/data-room-drawer/ShareDrawer'
import { CreateLinkDrawer } from '../components/data-room-drawer/CreateLinkDrawer'
import '../styles/DataRooms.scss'
import OutsideClickHandler from 'react-outside-click-handler'
import { DataRoomFilesModuleSectionDropdown } from '../components/DataRoomsFilesModuleSectionDropdown'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { errorMessage } from '../../profile/core/_constants'
import TagManager from 'react-gtm-module'
import { GTMEvent } from '../../../hooks/gtmHelpers'
import { NoDataPage } from '../../resources/components/NoDataPage'

function DataRoomsFiles() {
  const [menuOpen, setMenuOpen] = useState<number | null>(null)
  const [folders, setFolders] = useState<any>([])
  const { formatMessage } = useIntl()
  const { companyId, setShowBillingModal, currentUser } = useAuth()

  interface DataRoomFile {
    id: number
    img: string
    name: string
    lastModified: string
    recentVisits: number
    contentId: number
    parentId: number
    companyId: number
    type: string
    isDefaultDataRoomFolder: boolean
  }

  const [dataRoomsFilesList, setDataRoomsFilesList] = useState<DataRoomFile[]>([])
  const { setFolderNameErr, setBreadcrumbContentId, setShowDrawer } = useMoveToFolderData()
  const [createLoading, setCreateLoading] = useState<boolean>(false)
  const [showCreateFolderModal, setShowCreateFolderModal] = useState(false)
  const [newName, setNewName] = useState<string>('')
  const [breadcrumbs, setBreadcrumbs] = useState<any>([])
  const [insideFields, setInsideFields] = useState<any>([])
  const [folderContentId, setFolderContentId] = useState<number>(0)
  const [uploadFileContentId, setUploadFileContentId] = useState<number>(0)
  const [uploadOrAdd, setUploadOrAdd] = useState<boolean>(false)
  const [contentId, setContentId] = useState<string | undefined>()
  const [renameModalContentId, setRenameModalContentId] = useState<number | null>(null)
  const [dataRoomUploadsFolderContentId, setDataRoomUploadsFolderContentId] = useState<
    number | null
  >(null)
  const [companyFolderContentId, setCompanyFolderContentId] = useState<string | null>(null)
  const [showFolderIconBool, setShowFolderIconBool] = useState<boolean>(false)

  const [activeContentId, setActiveContentId] = useState(null)

  const [isLoading, setIsLoading] = useState(true)

  const getBreadcrumb = async (parentId: any, mainLevel?: boolean) => {
    try {
      const {
        data: { data, success: successData, errors: errorsData },
      } = await getBreadcrumbList(parentId)
      if (successData) {
        const reversedBreadcrumb = [...data.breadcrumb].reverse()
        setBreadcrumbs(reversedBreadcrumb)
        setInsideFields(data.results)
        if (mainLevel) {
          setActiveContentId(parentId)
        }
        if (data.breadcrumb.reverse()[0].id === dataRoomUploadsFolderContentId) {
          setShowFolderIconBool(true)
        } else {
          setShowFolderIconBool(false)
        }
      } else {
        errorsData.forEach((error: string) => {
          toast.error(formatMessage({ id: error }))
        })
      }
    } catch (err) {
      console.log(err)
    }
  }

  const getCompanyFolderChildren = async (parentId: any, mainLevel?: boolean) => {
    const compId: any = companyId
    try {
      const {
        data: { data, success: successData, errors: errorsData },
      } = await getCompanyChildrenList(parentId, compId)
      if (successData) {
        if (mainLevel) {
          setActiveContentId(parentId)
        }
        setBreadcrumbs(data.breadcrumb.reverse())
        setInsideFields(data.results)
        setShowFolderIconBool(false)
      } else {
        errorsData.forEach((error: string) => {
          toast.error(formatMessage({ id: error }))
        })
      }
    } catch (err) {
      console.log(err)
    }
  }

  const getAllFilesContent = async () => {
    try {
      const {
        data: { data, success, errors },
      } = await getAllContent()
      if (success) {
        setDataRoomsFilesList(data.results)
        setDataRoomUploadsFolderContentId(data.results[1]?.contentId)
      } else {
        errors.forEach((error: string) => {
          toast.error(formatMessage({ id: error }))
        })
      }
    } catch (err) {
      console.log(err)
    }
  }

  const handleCreateFolderClick = (id: number) => {
    setFolderContentId(id)
    setShowCreateFolderModal(true)
  }

  const getAllFolder = async () => {
    const cid: any = companyId
    try {
      const {
        data: { data, success: successData, errors: errorsData },
      } = await getAllFoldersList(cid)
      if (successData) {
        setCompanyFolderContentId(data.results[0]?.contentId)
        setFolders(data.results)
        getCompanyFolderChildren(data.results[0].contentId, true)
      } else {
        errorsData.forEach((error: string) => {
          toast.error(formatMessage({ id: error }))
        })
      }
    } catch (err) {
      console.log(err)
    }
  }

  const handleCreateFolder = async (
    type: string,
    companyId: number,
    newName: string,
    parentId: string
  ) => {
    if (!newName) {
      setFolderNameErr(true)
      return
    }
    try {
      setCreateLoading(true)
      if (companyId) {
        const {
          data: { success, errors },
        } = await addContent(type, companyId, newName, parentId)
        if (success) {
          setShowCreateFolderModal(false)
          toast.success(formatMessage({ id: 'Folder created successfully' }))
          setNewName('')
          if (parentId === companyFolderContentId) {
            getCompanyFolderChildren(parentId, true)
          } else {
            getBreadcrumb(parentId)
          }
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.DataRoomAddFolderSuccessful,
              action: 'normal',
              metadata: {
                type,
                company_id: companyId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                new_name: newName,
                parent_id: parentId,
              },
            },
          })
        } else {
          errors.forEach((error: string) => {
            if (
              error === errorMessage.UPGRADE_BILLING_PLAN_LIMIT_EXCEEDED ||
              error === errorMessage.UPGRADE_BILLING_PLAN_FEATURE
            ) {
              setShowBillingModal(true)
              toast.error(formatMessage({ id: error }), { autoClose: false })
            } else {
              toast.error(formatMessage({ id: error }))
            }
          })
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.DataRoomAddFolderFailed,
              action: 'normal',
              metadata: {
                type,
                company_id: companyId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                new_name: newName,
                parent_id: parentId,
                error: errors[0],
              },
            },
          })
          setNewName('')
        }
      }
    } catch (err) {
      console.log(err)
    } finally {
      setCreateLoading(false)
    }
  }
  setBreadcrumbContentId(breadcrumbs[breadcrumbs.length - 1]?.id)

  const handleUploadFilesClick = (id: number) => {
    setShowDrawer(true)
    setUploadFileContentId(id)
    setUploadOrAdd(true)
  }

  useEffect(() => {
    ; (async () => {
      await getAllFilesContent()
      await getAllFolder()

      // Once both functions have completed their tasks
      setIsLoading(false)
    })()
  }, []) // eslint-disable-line

  return (
    <>
      {/* {isLoading && <div />} */}
      <div className='data-rooms-files-module-wrapper pt-0 px-6'>
        <div className='Page_ToolBar-wrapper d-md-flex flex-row align-items-center justify-content-between'>
          <div className='Page_ToolBar-left'>
            <h4 className='mb-4'> {formatMessage({ id: 'Files' })}</h4>
            <p className='fw-semibold align-items-center d-flex font-size-12 text-primary'>
              <Link to='/' className='text-primary'>
                {formatMessage({ id: 'Home' })}
              </Link>
              <span className='h-1px bullet mx-2'></span>
              <span className='text-muted font-size-12'> {formatMessage({ id: 'Files' })}</span>
            </p>
            {/* <h5 className='mb-0 text-dark'>{formatMessage({id: 'Files'})}</h5>
            <ul className='breadcrumb breadcrumb-line text-muted fs-6 fw-bold'>
              <li className='breadcrumb-item pe-3'>
                <Link to={`/`} className='pe-3 item_link text-dark'>
                  {formatMessage({id: 'Home'})}
                </Link>
              </li>
              <li className='breadcrumb-item pe-3 text-muted text-dark'>
                {' '}
                {formatMessage({id: 'Files'})}
              </li>
            </ul> */}
          </div>
          <div className='Page_ToolBar-right d-flex flex-row align-items-center justify-content-md-end justify-content-between'>
            {!showFolderIconBool && (
              <div
                className='more-option bg-white margin_right-8px cursor-pointer'
                onClick={() => handleCreateFolderClick(breadcrumbs[breadcrumbs.length - 1]?.id)}
              >
                <img src={addFileIcon} alt=''></img>
              </div>
            )}
            <button
              className='btn custom-button-property bg-primary rounded font-size-13 text-white font-weight-400 height-36 d-flex align-items-center justify-content-center flex-grow-1 '
              onClick={() => {
                handleUploadFilesClick(breadcrumbs[breadcrumbs.length - 1]?.id)
              }}
            >
              {formatMessage({ id: 'Upload Files' })}
            </button>
          </div>
        </div>

        <div className='data-rooms-files-module-body d-md-flex flex-row bg-white'>
          <div className='data-rooms-files-module-body-left d-md-block d-none dark-border'>
            <section className='team-folder-wrapper'>
              <h5 className='text-dark'>{formatMessage({ id: 'Teams Folder' })}</h5>
              {isLoading ? (
                <Skeleton
                  count={3}
                  height={40}
                  style={{ marginTop: '10px' }}
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
              ) : (
                folders &&
                folders.map((item: any, id: number) => {
                  return (
                    <div
                      key={item.contentId}
                      className='team-folder-list d-flex flex-row align-items-center justify-content-between'
                    >
                      <div
                        className='d-flex flex-row align-items-center team-folder-list-div'
                        onClick={() => {
                          getCompanyFolderChildren(item.contentId, true)
                        }}
                      >
                        <img src={folderIcon} alt={formatMessage({ id: 'folderIcon' })}></img>
                        <span
                          className={`text-dark ${activeContentId === item.contentId ? 'active' : ''
                            }`}
                        >
                          {item.name}
                        </span>
                      </div>
                    </div>
                  )
                })
              )}
            </section>
            <section className='team-folder-wrapper'>
              <h5 className='text-dark'>{formatMessage({ id: 'My Folder' })}</h5>
              {isLoading ? (
                <Skeleton
                  count={5}
                  height={40}
                  style={{ marginTop: '10px' }}
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
              ) : (
                dataRoomsFilesList &&
                dataRoomsFilesList.map((item: any, id: number) => {
                  if (item.parentId === null && item.companyId === null) {
                    return (
                      <div
                        key={item.contentId}
                        className='team-folder-list  d-flex flex-row align-items-center justify-content-between'
                      >
                        <div
                          className='d-flex flex-row align-items-center team-folder-list-div'
                          onClick={() => {
                            getBreadcrumb(item.contentId, true)
                          }}
                        >
                          <img src={folderIcon} alt=''></img>
                          <span
                            className={`text-dark ${activeContentId === item.contentId ? 'active' : ''
                              }`}
                          >
                            {item.name}
                          </span>
                        </div>
                        <div className='files-module-section-option-wrapper'>
                          <div
                            className={`more-option-icon-box d-flex flex-row align-items-center justify-content-center ${menuOpen === item.contentId ? 'active' : ''
                              }`}
                            onClick={() =>
                              setMenuOpen(menuOpen !== item.contentId ? item.contentId : null)
                            }
                          >
                            <img src={moreOption} alt={formatMessage({ id: 'select_options' })}></img>
                          </div>
                          {renameModalContentId ? (
                            <OutsideClickHandler onOutsideClick={() => setMenuOpen(null)}>
                              <DataRoomFilesModuleSectionDropdown
                                isOpen={menuOpen === item.contentId}
                                contentId={item.contentId}
                                type={item.type}
                                name={item.name}
                                showRenameModal={renameModalContentId === item.contentId}
                                setShowRenameModal={setRenameModalContentId}
                                getAllFilesContent={getAllFilesContent}
                                setMenuOpen={setMenuOpen}
                              />
                            </OutsideClickHandler>
                          ) : (
                            <DataRoomFilesModuleSectionDropdown
                              isOpen={menuOpen === item.contentId}
                              contentId={item.contentId}
                              type={item.type}
                              name={item.name}
                              showRenameModal={renameModalContentId === item.contentId}
                              setShowRenameModal={setRenameModalContentId}
                              getAllFilesContent={getAllFilesContent}
                              setMenuOpen={setMenuOpen}
                            />
                          )}
                        </div>
                      </div>
                    )
                  }
                  return null
                })
              )}
            </section>
          </div>
          <div className='data-rooms-files-module-body-right flex-grow-1 '>
            {isLoading ? (
              <ul className='breadcrumb  text-muted  font-size-16 font-weight-600 '>
                <li>
                  <Skeleton
                    height={30}
                    width={440}
                    baseColor='var(--kt-skeleton-bg-color)'
                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                  />
                </li>
              </ul>
            ) : (
              breadcrumbs && (
                <ul className='breadcrumb  text-muted  font-size-16 font-weight-600 '>
                  {breadcrumbs.length > 0 && (
                    <li
                      className='breadcrumb-item pe-3 text-primary cursor-pointer'
                      onClick={() => {
                        if (companyFolderContentId === breadcrumbs[0].id) {
                          getCompanyFolderChildren(breadcrumbs[0].id)
                        } else {
                          getBreadcrumb(breadcrumbs[0].id)
                        }
                      }}
                    >
                      <img src={folderIcon} alt=''></img>
                      <span className='pe-3'>{breadcrumbs[0].name}</span>
                    </li>
                  )}
                  {breadcrumbs.length >= 1 &&
                    breadcrumbs.slice(1).map((item: any, id: number) => (
                      <li
                        className={`breadcrumb-item pe-3 ${id === 1 ? 'text-dark' : 'text-primary cursor-pointer'
                          }`}
                        key={id}
                        onClick={() => {
                          if (companyFolderContentId === activeContentId) {
                            getCompanyFolderChildren(item.id)
                          } else {
                            getBreadcrumb(item.id)
                          }
                        }}
                      >
                        <img src={folderIcon} alt=''></img>
                        <span className='pe-3'>{item.name}</span>
                      </li>
                    ))}
                </ul>
              )
            )}
            <div className='data-rooms-files-table-wrapper '>
              <table className='table table-row-bordered  space-table'>
                <thead>
                  <tr className='text-dark'>
                    <th>{formatMessage({ id: 'Name' })}</th>
                    <th>{formatMessage({ id: 'Last Modified' })}</th>
                    <th>{formatMessage({ id: 'Recent visits' })}</th>
                    <th>
                      <div className='d-flex align-items-center justify-content-end'>
                        {formatMessage({ id: 'Actions' })}
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {isLoading ? (
                    <tr>
                      <td colSpan={4}>
                        <Skeleton
                          count={5}
                          height={25}
                          style={{ marginTop: '10px', width: '100%' }}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </td>
                    </tr>
                  ) : (
                    // insideFields.map((item: any) => (
                    //   <DataRoomFilesTableRow
                    //     data={item}
                    //     getAllFilesContent={getAllFolder}
                    //     getBreadcrumb={getBreadcrumb}
                    //     setContentId={setContentId}
                    //     dataRoomUploadsFolderContentId={dataRoomUploadsFolderContentId}
                    //     getCompanyFolderChildren={getCompanyFolderChildren}
                    //     companyFolderContentId={companyFolderContentId}
                    //     activeContentId={activeContentId}
                    //   />
                    // ))
                    insideFields.length === 0 ?
                      <tr>
                        <td colSpan={4}>
                          <NoDataPage />
                        </td>
                      </tr>
                      :
                      insideFields.map((item: any) => (
                        <DataRoomFilesTableRow
                          data={item}
                          getAllFilesContent={getAllFolder}
                          getBreadcrumb={getBreadcrumb}
                          setContentId={setContentId}
                          dataRoomUploadsFolderContentId={dataRoomUploadsFolderContentId}
                          getCompanyFolderChildren={getCompanyFolderChildren}
                          companyFolderContentId={companyFolderContentId}
                          activeContentId={activeContentId}
                        />
                      ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <UploadDrawer />
        <DeleteFileModal />
        <UploadOptionsDrawer
          getBreadcrumb={getBreadcrumb}
          uploadFileContentId={uploadFileContentId}
          uploadOrAdd={uploadOrAdd}
          setUploadOrAdd={setUploadOrAdd}
          getCompanyFolderChildren={getCompanyFolderChildren}
          companyFolderContentId={companyFolderContentId}
        />
        <AddFolderModal
          renameFolderModal={showCreateFolderModal}
          setRenameFolderModal={setShowCreateFolderModal}
          onFolderRename={handleCreateFolder}
          renameLoading={createLoading}
          folderRenameId={companyId}
          newName={newName}
          setNewName={setNewName}
          heading={formatMessage({ id: 'Create' })}
          labelText={formatMessage({ id: 'Please type the name of your folder' })}
          btnText={formatMessage({ id: 'Create Folder' })}
          showBool={true}
          folderParentId={folderContentId}
        />
        <ShareDrawer contentId={contentId} />
        <CreateLinkDrawer contentId={contentId} />
      </div>
    </>
  )
}

export default DataRoomsFiles
